import styled from "@emotion/styled";

export const MDSDialogTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const MDSDialogHeaderContent = styled.div<{ allowOverflow?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  overflow: ${({ allowOverflow }) => (allowOverflow ? "visible" : "hidden")};
`;
